import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import Spinner from '../Spinner/Spinner'
import { Table, Button, Alert } from 'reactstrap'
import { publishEvent } from '../../utils'
import { ACTIVITY_LOG_DETAIL_QUERY } from '../../graphql'
// import PaginationPageControls from '../Pagination/PaginationPageControls'
// import PaginationRecordMenu from '../Pagination/PaginationRecordMenu'
import { useNavigate } from 'react-router-dom'

const ACTIVITY_LOG_DETAIL = gql(ACTIVITY_LOG_DETAIL_QUERY)

export default function ActivityLogDetail({ parameters, location }) {
  console.log('ActivityLogDetail rendered: ', parameters, location)
  const navigate = useNavigate()

  const { loading, error, data } = useQuery(ACTIVITY_LOG_DETAIL, {
    variables: {
      objectTypeId: parseInt(parameters.objectTypeId),
      actionUserId: parseInt(parameters.actionUserId),
      fromDate: parameters.fromDate,
      toDate: parameters.toDate,
      start: parameters.start
    }
  })

  if (loading) {
    return <Spinner />
  }
  if (error) {
    return <Alert color="danger">{error.message}</Alert>
  }

  function userClicked(actionUserId) {
    publishEvent('ACTIVITY LOG USER CLICKED', actionUserId, 'ActivityLogDetail.userClicked')
  }

  const rows = []
  if (data.getActionDetail) {
    data.getActionDetail.actions.forEach((dataRow, index) => {
      const row =
        <tr key={index}>
          <td>{parameters.start+index}</td>
          <td><Button className="activitylog-detail-link" color="link" onClick={() => userClicked(dataRow.userId)}>{dataRow.userName}</Button></td>
          <td>{dataRow.actionDate}</td>
          <td className="right">{dataRow.actionName}</td>
          <td><Button style={{ padding: '0' }} color="link" onClick={() => navigate(`/object/${dataRow.objectId}`)}>{dataRow.objectTypeName}</Button></td>
        </tr>
      rows.push(row)
    })
  }

  return (
    <div style={{ padding: '5px' }}>
      <div className="activitylog-grid-table-container">
        <Table className="activitylog-grid-table" bordered size="sm">
          <thead>
            <tr>
              <th>#</th>
              <th>User Name</th>
              <th>Event Date</th>
              <th>Event Type</th>
              <th>Document Type</th>
            </tr>
          </thead>
          <tbody>
            {rows}
          </tbody>
        </Table>
      </div>
    </div>
  )
}